<template>
  <div class="full-screen-cropper-picture-page">
    <popup ref="popup" fullScreen :visible="true" cancelTxt="" confirmTxt="">
      <div class="picture-add-dialog">
        <rich-loading v-if="loading"></rich-loading>
        <div class="cropper-container" :style="cutOptions.containerStyle">
          <VueCropperEdit
            v-show="!loading"
            ref="cropper2"
            :img="imageData"
            :full="cutOptions.full"
            :mode="cutOptions.mode"
            :can-scale="cutOptions.canScale"
            :can-move="cutOptions.canMove"
            :can-move-box="cutOptions.canMoveBox"
            :auto-crop="cutOptions.autoCrop"
            :max-crop-width="cutOptions.maxImgWidth"
            :max-crop-height="cutOptions.maxImgHeight"
            :min-crop-width="cutOptions.minImgWidth"
            :min-crop-height="cutOptions.minImgHeight"
            :auto-crop-width="cutOptions.autoCropWidth"
            :auto-crop-height="cutOptions.autoCropHeight"
            :fixed="cutOptions.fixed"
            :original="cutOptions.original"
            :center-box="cutOptions.centerBox"
            :fixed-number="cutOptions.fixedNumber"
            :fixed-box="cutOptions.fixedBox"
            :output-size="cutOptions.outputSize"
            :output-type="cutOptions.outputType"
          />
        </div>
        <div class="buttons" v-show="!loading">
          <div class="cancel" v-show="!isLoading"  @click="cancelAddPicture()">
            {{ gettext("取消") }}
          </div>
          <div class="confirm" @click="cutPicture()">
            {{ gettext("确定") }}
          </div>
        </div>
      </div>
    </popup>
  </div>
</template>
<script>
import Popup from './Popup'
import VueCropperEdit from '@/components/vue-cropper/vue-cropper'
import { getOrientation } from '@/components/vue-cropper/exif-js-min'
import { prefixUrl, getCommonParams, request } from '@/common/utils/request'
import { trackEvent } from '@/common/utils/log'
import { get } from 'lodash'

export default {
  name: 'FullCutPicture',
  components: {
    Popup,
    VueCropperEdit
  },
  inject: ['rootForm'],
  props: {
    file: {
      type: File,
      default: ''
    },
    value: {
      type: Object
    },
    item: {
      type: Object,
      default: () => {},
    },
    target: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      isLoading: false,
      imageData: '',
      cutOptions: {
        containerStyle: {},
        fixed: true,
        fixedBox: true,
        fixedNumber: [1, 1],
        full: true,
        mode: 'auto',
        outputSize: 1,
        outputType: 'png',
        maxImgWidth: 300,
        maxImgHeight: 300,
        minImgWidth: 200,
        minImgHeight: 200,
        autoCropWidth: 200,
        autoCropHeight: 200,
        sizeLimitErrMsg: this.$t(
          'FoodB_optimization__bdZL' /** 请上传5M以内且不小于200*200的图片，支持jpg、png格式。 */
        ),
        canScale: true,
        canMove: true,
        canMoveBox: false,
        autoCrop: true,
        original: false,
        centerBox: true,
        falg: true,
        ...this.item.customCropper
      }
    }
  },
  watch: {
    file: {
      deep: true,
      handler(nVal) {
        this.getImageData(nVal)
      }
    },
    isLoading: {
      deep: true,
      handler(nVal) {
        this.isLoading = nVal
      }
    }
  },
  methods: {
    show() {
      this.$refs.popup.show()
    },
    hide() {
      this.$refs.popup.hide()
      this.imageData = ''
    },
    cancelAddPicture() {
      this.rootForm.internalData[this.item.prop] = []
      this.$refs.popup.hide()
    },
    // 确认裁剪
    cutPicture() {
      this.loading = true
      this.$refs.cropper2.getCropBlob(async blob => {
        let size = 10
        const isLtSize = blob.size < size * 1024 * 1024
        if (!isLtSize) {
        } else {
          const name = this.file.name
          const upfile = new File([blob], name, { type: 'image/png' })
          upfile.uid = new Date().getTime()
          let uploadRes = await this.customHttpRequest(upfile)
          if (uploadRes.errno === 0) {
            trackEvent('sailing_m_b_logo_corp_ok_ck', {
              url: window.location.href,
              page: this.item.customCropper.page
            })
            if (this.item.transformWebp) {
              const images = [{
                key: get(uploadRes, 'data.key', ''),
                url: get(uploadRes, 'data.url', '')
              }]
              const fileToWebpRes = await this.convertWebp({ images })
              if (!fileToWebpRes || !get(fileToWebpRes, 'data', '')) {
                this.cancelAddPicture()
                this.hide()
                const ebpErrorToast = this.$createToast({
                  type: 'txt',
                  txt: this.gettext('上传失败，请重新上传')
                })
                ebpErrorToast.show()
                setTimeout(() => {
                  ebpErrorToast.hide()
                }, 2000)
                return
              }
            }
            this.rootForm.internalData[this.item.prop].push({
              customUrl: uploadRes.data.url
            })
            this.loading = false
            this.hide()
            const toast = this.$createToast({
              type: 'txt',
              txt: this.gettext('成功')
            })
            toast.show()
            setTimeout(() => {
              toast.hide()
            }, 2000)
          } else {
            const toast = this.$createToast({
              type: 'txt',
              txt: this.gettext('上传失败，请重新上传')
            })
            toast.show()
            setTimeout(() => {
              toast.hide()
            }, 2000)
          }
        }
      })
    },
    // 转换为webp格式: https://mock.xiaojukeji.com/project/12860/interface/api/806577
    async convertWebp(params) {
      return request.post({
        url: 'taxue.common.convertWebp',
        data: params
      }).catch((e) => {
        console.log('[log]e', e)
      })
    },

    // 上传函数
    customHttpRequest(file) {
      return new Promise((resolve, reject) => {
        function getBody(xhr) {
          const text = xhr.responseText || xhr.response
          if (!text) {
            return text
          }
          try {
            return JSON.parse(text)
          } catch (e) {
            return text
          }
        }
        let form = new FormData()
        // XHR对象
        let xhr = new XMLHttpRequest()
        form.append('upfile', file)
        xhr.open('post', this.target, true)
        xhr.onload = () => {
          if (xhr.status < 200 || xhr.status >= 300) {
            this.cancelAddPicture()
            reject(xhr)
          }
          let responseBody = getBody(xhr)
          if (responseBody.urlHttps) {
            resolve({
              ...responseBody,
              url: responseBody.urlHttps
            })
          }
          resolve(responseBody)
        }
        // 设置headers
        let headers = getCommonParams()
        for (let item in headers) {
          if (headers.hasOwnProperty(item) && headers[item] !== null) {
            form.append(item, headers[item])
          }
        }
        xhr.send(form)
      })
    },
    async getImageData(file) {
      let reader = new FileReader()
      reader.readAsArrayBuffer(file)
      reader.onload = async e => {
        let data
        if (typeof e.target.result === 'object') {
          data = window.URL.createObjectURL(new Blob([e.target.result]))
        } else {
          data = e.target.result
        }
        let { width, height } = await this.getImageWidthHeight(data)
        let picWidth = width
        let picHeight = height
        // 图片旋转角度 https://www.cnblogs.com/suyuanli/p/8168407.html
        const orient = getOrientation(e.target.result)
        switch (orient) {
          case 6: // 顺时针90°
          case 8: // 逆时针90
            picWidth = height
            picHeight = width
            break
        }
        // 判断图片宽高是否满足最低尺寸
        if (
          picWidth < this.cutOptions.minImgWidth
          || picHeight < this.cutOptions.minImgHeight
        ) {
          const toast = this.$createToast({
            type: 'txt',
            txt: `${this.cutOptions.sizeLimitErrMsg}`
          })
          toast.show()
          setTimeout(() => {
            toast.hide()
          }, 2000)

          this.cancelAddPicture()
          return
        }
        const { autoCropWidth, autoCropHeight } = this.cutOptions
        // 如果屏幕大于图片尺寸
        if (picWidth / picHeight > autoCropWidth / autoCropHeight) {
          // 根据宽适配
          this.cutOptions.mode = `auto ${autoCropHeight}px`
          this.cutOptions.containerStyle = {
            width: `100vw`,
            height: `${autoCropHeight}px`
          }
        } else {
          // 根据高适配
          this.cutOptions.mode = `${autoCropWidth}px auto`
          this.cutOptions.containerStyle = {
            width: `${autoCropWidth}px`,
            height: `calc(100vh - 120Px)`
          }
        }
        this.imageData = data
      }
    },
    // 获取图片的长宽
    getImageWidthHeight(imgUrl) {
      return new Promise(resolve => {
        let image = new Image()
        image.src = imgUrl
        image.onload = function() {
          resolve({ width: this.width, height: this.height })
        }
        image.onerror = function() {
          resolve({ width: 0, height: 0 })
        }
      })
    }
  },
  mounted() {
    this.getImageData(this.file)
  }
}
</script>

<style lang="scss">
.full-screen-cropper-picture-page {
  overflow: hidden;
  height: 100%;
  position: relative;

  .popup {
    .popup-panel {
      .popup-choose {
        display: none; // 隐藏 popup 的 titlebar
      }
    }
  }
}
.picture-add-dialog {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #333740;
  overflow: scroll;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .cropper-container {
    max-width: 100vw;
    max-height: calc(100vh - 120Px);
  }

  .buttons {
    text-align: center;
    margin-top: 60px;
    .cancel,
    .confirm {
      display: inline-block;
      color: #ffffff;
      cursor: pointer;
      font-size: 32px;
    }
    .cancel {
      margin-right: 80px;
    }
  }
}
</style>
